import styled from 'styled-components/macro'
import Typography from '@material-ui/core/Typography'

const EmptyNemesisHint = styled(Typography)``

EmptyNemesisHint.displayName = 'EmptyNemesisHint'

export default EmptyNemesisHint
